module.exports = __webpack_public_path__ + "static/portsmouth-banner.789a7d5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portsmouth-banner.jpg
// module id = 479
// module chunks = 155501002171372